// DO NOT EDIT -- generated from fs/services/dex/dataexport.proto

import * as protobuf from '../../../google/protobuf';
import * as segment from '../../api/segment';

export namespace DataExport {

  // unsupported streaming endpoint
  export const ListExportsEndpoint = "/grpc/dexapi.DataExport/ListExports";

  export const GetExportUrlEndpoint = "/grpc/dexapi.DataExport/GetExportUrl";
  /** Generate a temporary, signed URL for a given export. */
  export function GetExportUrl(sender: (req: Export, endpoint: string) => Promise<GetExportUrlResponse>, req: Export): { promise: () => Promise<GetExportUrlResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetExportUrlEndpoint),
      endpoint: GetExportUrlEndpoint
    };
  }

  export const GetExportUserUrlEndpoint = "/grpc/dexapi.DataExport/GetExportUserUrl";
  /** Generate a temporary, signed URL for downloading user events/pages of a given user. */
  export function GetExportUserUrl(sender: (req: ExportUserRequest, endpoint: string) => Promise<GetExportUrlResponse>, req: ExportUserRequest): { promise: () => Promise<GetExportUrlResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetExportUserUrlEndpoint),
      endpoint: GetExportUserUrlEndpoint
    };
  }
}

export namespace SearchExportAdmin {

  export const CreateInternalSearchExportEndpoint = "/grpc/dexapi.SearchExportAdmin/CreateInternalSearchExport";
  /** CreateSearchExport creates a data export job that will be scoped to the search or segment. */
  export function CreateInternalSearchExport(sender: (req: CreateSearchExportRequest, endpoint: string) => Promise<CreateSearchExportResponse>, req: CreateSearchExportRequest): { promise: () => Promise<CreateSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateInternalSearchExportEndpoint),
      endpoint: CreateInternalSearchExportEndpoint
    };
  }

  export const ListInternalSearchExportsEndpoint = "/grpc/dexapi.SearchExportAdmin/ListInternalSearchExports";
  /** ListInternalSearchExports retrieves a list of internal search exports, with pagination. */
  export function ListInternalSearchExports(sender: (req: ListSearchExportsRequest, endpoint: string) => Promise<ListSearchExportsResponse>, req: ListSearchExportsRequest): { promise: () => Promise<ListSearchExportsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListInternalSearchExportsEndpoint),
      endpoint: ListInternalSearchExportsEndpoint
    };
  }
}

/** TODO(cam|luke): this service should eventually become the main dex API, but will be separate during the prototype phase. */
export namespace SearchExporter {

  export const CreateSearchExportEndpoint = "/grpc/dexapi.SearchExporter/CreateSearchExport";
  /** CreateSearchExport creates a data export job that will be scoped to the search or segment. */
  export function CreateSearchExport(sender: (req: CreateSearchExportRequest, endpoint: string) => Promise<CreateSearchExportResponse>, req: CreateSearchExportRequest): { promise: () => Promise<CreateSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSearchExportEndpoint),
      endpoint: CreateSearchExportEndpoint
    };
  }

  export const GetSearchExportEndpoint = "/grpc/dexapi.SearchExporter/GetSearchExport";
  /** GetSearchExport retrieves a single search export. */
  export function GetSearchExport(sender: (req: GetSearchExportRequest, endpoint: string) => Promise<GetSearchExportResponse>, req: GetSearchExportRequest): { promise: () => Promise<GetSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSearchExportEndpoint),
      endpoint: GetSearchExportEndpoint
    };
  }

  export const BatchGetSearchExportProgressEndpoint = "/grpc/dexapi.SearchExporter/BatchGetSearchExportProgress";
  /**
   * BatchGetSearchExportProgress retrieves the progress of a batch of search exports.
   * All requested ids are guaranteed to be provided in the response.
   * This serves as a more efficient cost reduced endpoint to track progress of active exports.
   * Once an export moves to finished, it generally shouldn't continue to be requested here as it effectively
   * acts like GetSearchExport for finished exports.
   * Expected error codes:
   *   NotFound: If any search export is not found.
   *   InvalidArgument: If no ids or more than 100 ids are provided.
   */
  export function BatchGetSearchExportProgress(sender: (req: BatchGetSearchExportProgressRequest, endpoint: string) => Promise<BatchGetSearchExportProgressResponse>, req: BatchGetSearchExportProgressRequest): { promise: () => Promise<BatchGetSearchExportProgressResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSearchExportProgressEndpoint),
      endpoint: BatchGetSearchExportProgressEndpoint
    };
  }

  export const ListSearchExportsEndpoint = "/grpc/dexapi.SearchExporter/ListSearchExports";
  /** ListSearchExports retrieves a list of search exports, with pagination. */
  export function ListSearchExports(sender: (req: ListSearchExportsRequest, endpoint: string) => Promise<ListSearchExportsResponse>, req: ListSearchExportsRequest): { promise: () => Promise<ListSearchExportsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSearchExportsEndpoint),
      endpoint: ListSearchExportsEndpoint
    };
  }

  export const GetSearchExportResultsEndpoint = "/grpc/dexapi.SearchExporter/GetSearchExportResults";
  /**
   * GetSearchExportResults returns a shortlived, signed url to a GCS object containing
   * the exported documents.
   */
  export function GetSearchExportResults(sender: (req: GetSearchExportResultsRequest, endpoint: string) => Promise<GetSearchExportResultsResponse>, req: GetSearchExportResultsRequest): { promise: () => Promise<GetSearchExportResultsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSearchExportResultsEndpoint),
      endpoint: GetSearchExportResultsEndpoint
    };
  }

  export const CancelSearchExportEndpoint = "/grpc/dexapi.SearchExporter/CancelSearchExport";
  /** CancelSearchExport stops an in-progress export from running. */
  export function CancelSearchExport(sender: (req: CancelSearchExportRequest, endpoint: string) => Promise<CancelSearchExportResponse>, req: CancelSearchExportRequest): { promise: () => Promise<CancelSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CancelSearchExportEndpoint),
      endpoint: CancelSearchExportEndpoint
    };
  }
}

export namespace SearchExporterPublic {

  export const CreateSearchExportEndpoint = "/grpc/dexapi.SearchExporterPublic/CreateSearchExport";
  /** CreateSearchExport creates a data export job that will be scoped to the search or segment. */
  export function CreateSearchExport(sender: (req: CreateSearchExportRequest, endpoint: string) => Promise<CreateSearchExportResponse>, req: CreateSearchExportRequest): { promise: () => Promise<CreateSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateSearchExportEndpoint),
      endpoint: CreateSearchExportEndpoint
    };
  }

  export const GetSearchExportEndpoint = "/grpc/dexapi.SearchExporterPublic/GetSearchExport";
  /** GetSearchExport retrieves a single search export. */
  export function GetSearchExport(sender: (req: GetSearchExportRequest, endpoint: string) => Promise<GetSearchExportResponse>, req: GetSearchExportRequest): { promise: () => Promise<GetSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSearchExportEndpoint),
      endpoint: GetSearchExportEndpoint
    };
  }

  export const BatchGetSearchExportProgressEndpoint = "/grpc/dexapi.SearchExporterPublic/BatchGetSearchExportProgress";
  /**
   * BatchGetSearchExportProgress retrieves the progress of a batch of search exports.
   * All requested ids are guaranteed to be provided in the response.
   * This serves as a more efficient cost reduced endpoint to track progress of active exports.
   * Once an export moves to finished, it generally shouldn't continue to be requested here as it effectively
   * acts like GetSearchExport for finished exports.
   * Expected error codes:
   *   NotFound: If any search export is not found.
   *   InvalidArgument: If no ids or more than 100 ids are provided.
   */
  export function BatchGetSearchExportProgress(sender: (req: BatchGetSearchExportProgressRequest, endpoint: string) => Promise<BatchGetSearchExportProgressResponse>, req: BatchGetSearchExportProgressRequest): { promise: () => Promise<BatchGetSearchExportProgressResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetSearchExportProgressEndpoint),
      endpoint: BatchGetSearchExportProgressEndpoint
    };
  }

  export const ListSearchExportsEndpoint = "/grpc/dexapi.SearchExporterPublic/ListSearchExports";
  /** ListSearchExports retrieves a list of search exports, with pagination. */
  export function ListSearchExports(sender: (req: ListSearchExportsRequest, endpoint: string) => Promise<ListSearchExportsResponse>, req: ListSearchExportsRequest): { promise: () => Promise<ListSearchExportsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ListSearchExportsEndpoint),
      endpoint: ListSearchExportsEndpoint
    };
  }

  export const GetSearchExportResultsEndpoint = "/grpc/dexapi.SearchExporterPublic/GetSearchExportResults";
  /**
   * GetSearchExportResults returns a shortlived, signed url to a GCS object containing
   * the exported documents.
   */
  export function GetSearchExportResults(sender: (req: GetSearchExportResultsRequest, endpoint: string) => Promise<GetSearchExportResultsResponse>, req: GetSearchExportResultsRequest): { promise: () => Promise<GetSearchExportResultsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSearchExportResultsEndpoint),
      endpoint: GetSearchExportResultsEndpoint
    };
  }

  export const CancelSearchExportEndpoint = "/grpc/dexapi.SearchExporterPublic/CancelSearchExport";
  /** CancelSearchExport stops an in-progress export from running. */
  export function CancelSearchExport(sender: (req: CancelSearchExportRequest, endpoint: string) => Promise<CancelSearchExportResponse>, req: CancelSearchExportRequest): { promise: () => Promise<CancelSearchExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CancelSearchExportEndpoint),
      endpoint: CancelSearchExportEndpoint
    };
  }
}

export namespace LegacyCSVExportPublic {

  export const CreateUserExportEndpoint = "/grpc/dexapi.LegacyCSVExportPublic/CreateUserExport";
  /** CreateUserListExport supports a legacy feature where user lists can be downloaded from a searchie. */
  export function CreateUserExport(sender: (req: CreateUserExportRequest, endpoint: string) => Promise<CreateUserExportResponse>, req: CreateUserExportRequest): { promise: () => Promise<CreateUserExportResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUserExportEndpoint),
      endpoint: CreateUserExportEndpoint
    };
  }
}

export interface CreateUserExportRequest {
  orgId: string;
  /**
   * Optional. The id of the segment of the form "<creator_email>:<id>" or a canned segment (i.e. "everyone").
   * If not provided, segment_definition and name must both be provided.
   */
  segmentId: string;
  /** Name to use for the downloaded file. */
  name: string;
  /** Optional. If provided, this value will be used in place of the segment definition. */
  segmentDefinition: segment.SegmentDefinition | null;
  /** If supplied, overrides the time zone (defaults to UTC). */
  timezone: string;
}

export interface CreateUserExportResponse {
  downloadLink: string;
}

export interface ListExportsRequest {
  /** Time from which to start calculating bundle spans, going backwards */
  now: protobuf.timestamp | null;
  /** Length of each bundle span */
  exportInterval: protobuf.duration | null;
  /** Start of data retention window, i.e. the earliest date/time at which we expect there to be export data */
  retentionStart: protobuf.timestamp | null;
  /** Maximum number of results to return. */
  max: number;
  /**
   * The OrgId that we want to scope this request to.
   * NOTE: Ideally this would be field 1.
   */
  orgId: string;
}

export interface Export {
  start: protobuf.timestamp | null;
  stop: protobuf.timestamp | null;
  id: protobuf.int64;
  /**
   * The OrgId that we want to scope this request to.
   * NOTE: Ideally this would be field 1.
   */
  orgId: string;
}

export interface ExportUserRequest {
  kind: UserExportKind;
  appId: string;
  userId: protobuf.int64;
  /**
   * The OrgId that we want to scope this request to.
   * NOTE: Ideally this would be field 1.
   */
  orgId: string;
}

export enum UserExportKind {
  USER_EVENTS = 0,
  USER_PAGES = 1
}

export interface GetExportUrlResponse {
  signedUrl: string;
}

export interface CreateSearchExportRequest {
  orgId: string;
  /**
   * Optional. If provided, subsequent calls with the same idempotence key for this org will result in receiving a
   * reference to the preexisting export rather than initiating a new export. It is recommended to prefix the
   * idempotence key with some text related to purpose (i.e. "user-list:abc123").
   * If not provided, a uuid is generated automatically resulting in a new export being created for each call.
   */
  idempotenceKey: string;
  /**
   * Optional. The id of the segment of the form "<creator_email>:<id>" or a canned segment (i.e. "everyone").
   * If not provided, segment_definition and name must both be provided.
   */
  segmentId: string;
  /**
   * If provided, this time range overrides the time range constraint for the segment
   * corresponding to the segment id.
   */
  segmentTimeRange: segment.TimeRange | null;
  /** Optional. If provided, this value will be used in place of the segment definition. */
  segmentDefinition: segment.SegmentDefinition | null;
  /** Optional. If provided, this value will be used in place of the segment name. */
  name: string;
  /** The type of search export to initiate. */
  type: SearchExport.Type;
  eventDetails?: CreateSearchExportRequest.EventDetails | null;
  individualDetails?: {} | null;
  legacyUserListDetails?: {} | null;
  legacyEventDetails?: {} | null;
  /**
   * If provided, this time range restricts the resulting docs to this time range. For events, this is
   * based on EventStart, and for users, this is based on UserCreated.
   */
  timeRange: segment.TimeRange | null;
  /** The format to be used for the produced export. */
  format: SearchExport.Format;
  /** If supplied, overrides the now time for relative timestamps. */
  now: protobuf.timestamp | null;
  /** If supplied, overrides the time zone (defaults to UTC). */
  timezone: string;
  /**
   * If specified, then only the fields in this list will be included in the export.
   * Otherwise, the default set of fields will be exported.
   */
  fields: string[];
  /**
   * For internal use only. If true, all solr fields will be exported.
   * Note: the `fields` field above will be ignored and the CSV format is not available if this is true.
   */
  allRawFields: boolean;
}

export namespace CreateSearchExportRequest {
  export enum type_details {
    eventDetails = 6,
    individualDetails = 7,
    legacyUserListDetails = 13,
    legacyEventDetails = 14
  }

  export function type_details_oneof(m: CreateSearchExportRequest): { opt: type_details.eventDetails, val: CreateSearchExportRequest.EventDetails } | { opt: type_details.individualDetails, val: {} } | { opt: type_details.legacyEventDetails, val: {} } | { opt: type_details.legacyUserListDetails, val: {} } | null {
    if (m.eventDetails != null) { return { opt: type_details.eventDetails, val: m.eventDetails } }
    if (m.individualDetails != null) { return { opt: type_details.individualDetails, val: m.individualDetails } }
    if (m.legacyUserListDetails != null) { return { opt: type_details.legacyUserListDetails, val: m.legacyUserListDetails } }
    if (m.legacyEventDetails != null) { return { opt: type_details.legacyEventDetails, val: m.legacyEventDetails } }
    return null;
  }

  export interface EventDetails {
    /**
     * The interpretation of matching events to export.
     * If not provided, will default to exact matching events.
     */
    interpretation: SearchExport.EventDetails.Interpretation;
  }
}

export interface CreateSearchExportResponse {
  export: SearchExport | null;
}

export interface GetSearchExportRequest {
  orgId: string;
  id: string;
}

export interface GetSearchExportResponse {
  searchExport: SearchExport | null;
}

export interface BatchGetSearchExportProgressRequest {
  orgId: string;
  ids: string[];
}

export interface BatchGetSearchExportProgressResponse {
  inProgress: BatchGetSearchExportProgressResponse.SearchExportProgress[];
  finished: SearchExport[];
}

export namespace BatchGetSearchExportProgressResponse {
  export interface SearchExportProgress {
    id: string;
    docsProcessedEstimate: protobuf.int64;
    docsTotalEstimate: protobuf.int64;
  }
}

export interface ListSearchExportsPaginationToken {
  cursor?: string;
}

export namespace ListSearchExportsPaginationToken {
  export enum type {
    cursor = 1
  }

  export function type_oneof(m: ListSearchExportsPaginationToken): { opt: type.cursor, val: string } | null {
    if (m.cursor != null) { return { opt: type.cursor, val: m.cursor } }
    return null;
  }
}

export interface ListSearchExportsRequest {
  orgId: string;
  /** Optional. Limits the results to exports with states in the provided state rollup. */
  stateRollup: SearchExport.StateRollup;
  /** Optional. Limits the results to the provided creator. */
  creator: string;
  /** Optional (defaults to the max of 100). Limits the results. */
  limit: number;
  /**
   * If supplied from a previous request, continues the result set.
   * Note: The remaining request params are expected to be the same as originally supplied.
   *       Format is a base64 url encoded ListSearchExportsPaginationToken object.
   */
  paginationToken: string;
}

export interface ListSearchExportsResponse {
  /** Ordered search exports, descending by created time. */
  searchExports: SearchExport[];
  /** If non empty, the next batch of results can be retrieved through an additional request using this token. */
  nextPaginationToken: string;
}

export interface GetSearchExportResultsRequest {
  orgId: string;
  id: string;
  /** If true, wait until the export has completed or until a timeout occurs (as specified by the client). */
  wait: boolean;
}

export interface GetSearchExportResultsResponse {
  /** A signed URI pointing to the downloadable file. */
  location: string;
  /** The UTC time at which the location link expires. */
  expires: protobuf.timestamp | null;
}

export interface CancelSearchExportRequest {
  orgId: string;
  id: string;
}

export interface CancelSearchExportResponse {
  searchExport: SearchExport | null;
}

export interface SearchExport {
  /** The unique identifier of the search export. */
  id: string;
  /** The type of search export. The corresponding details will be filled in based on type. */
  type: SearchExport.Type;
  /** Identifier for who triggered the export. */
  creator: string;
  /** The name of the segment at the time of creation. */
  name: string;
  /**
   * If present, the ID of the segment at the time of creation.
   * If absent, the segment definition was provided ad-hoc.
   */
  segmentId: string;
  /**
   * The segment definition used to produce the search export results.
   * If a segment id was provided, this segment definition is the retrieved definition at the time of initialization.
   */
  segmentDefinition: segment.SegmentDefinition | null;
  /** If present, the absolute start time for the export inclusive. Otherwise, no start time bound is applied. */
  absoluteStart: protobuf.timestamp | null;
  /** If present, the absolute end time for the export, exclusive. Otherwise, no end time bound is applied. */
  absoluteEnd: protobuf.timestamp | null;
  /** Current state of export. */
  state: SearchExport.State;
  /** Current state rollup of the export. The state rollup is a function of the more fine grained state. */
  stateRollup: SearchExport.StateRollup;
  eventDetails?: SearchExport.EventDetails | null;
  individualDetails?: {} | null;
  legacyUserListDetails?: {} | null;
  legacyEventDetails?: {} | null;
  sessionDetails?: {} | null;
  /** The format to be used for the produced export. */
  format: SearchExport.Format;
  /** The time at which the search export was created. */
  created: protobuf.timestamp | null;
  /**
   * The time at which the search export reached a terminal, finished state.
   * Set once state rollup transitions to one of COMPLETED or FAILED.
   */
  finished: protobuf.timestamp | null;
  /**
   * The time at which the search export results expire.
   * Set once finished is set.
   */
  expires: protobuf.timestamp | null;
  /** If supplied, overrides the now time for relative timestamps. */
  now: protobuf.timestamp | null;
  /** If supplied, overrides the time zone (defaults to UTC). */
  timezone: string;
  /**
   * Indicates the number of docs processed (estimate). This value may not be up to date and could exceed the total
   * estimate while running (due to coalescing, newly indexed data, retention, etc.). When the export is complete,
   * this field will explicitly be set to the total docs estimate.
   */
  docsProcessedEstimate: protobuf.int64;
  /**
   * Indicates the number of docs expected to be exported (estimate). The number of records in the resulting export
   * will likely mismatch the total estimate when complete (due to coalescing, newly indexed data, retention, etc.).
   */
  docsTotalEstimate: protobuf.int64;
  /**
   * Present if state == FAILED.
   * Note: Not all FAILED state rollups will have a failure details.
   */
  failureDetails: string;
}

export namespace SearchExport {
  export enum type_details {
    eventDetails = 3,
    individualDetails = 4,
    legacyUserListDetails = 22,
    legacyEventDetails = 23,
    sessionDetails = 24
  }

  export function type_details_oneof(m: SearchExport): { opt: type_details.eventDetails, val: SearchExport.EventDetails } | { opt: type_details.individualDetails, val: {} } | { opt: type_details.legacyEventDetails, val: {} } | { opt: type_details.legacyUserListDetails, val: {} } | { opt: type_details.sessionDetails, val: {} } | null {
    if (m.eventDetails != null) { return { opt: type_details.eventDetails, val: m.eventDetails } }
    if (m.individualDetails != null) { return { opt: type_details.individualDetails, val: m.individualDetails } }
    if (m.legacyUserListDetails != null) { return { opt: type_details.legacyUserListDetails, val: m.legacyUserListDetails } }
    if (m.legacyEventDetails != null) { return { opt: type_details.legacyEventDetails, val: m.legacyEventDetails } }
    if (m.sessionDetails != null) { return { opt: type_details.sessionDetails, val: m.sessionDetails } }
    return null;
  }

  export enum State {
    STATE_INVALID = 0,
    STATE_SCHEDULED = 1,
    STATE_INITIALIZED = 2,
    STATE_IN_PROGRESS = 3,
    STATE_CANCELED = 4,
    STATE_COMPLETED = 5,
    STATE_EXPIRED = 6,
    STATE_FAILED = 7
  }

  export enum StateRollup {
    STATE_ROLLUP_INVALID = 0,
    STATE_ROLLUP_PENDING = 1,
    STATE_ROLLUP_COMPLETED = 2,
    STATE_ROLLUP_FAILED = 3
  }

  export enum Type {
    TYPE_INVALID = 0,
    TYPE_EVENT = 1,
    TYPE_INDIVIDUAL = 2,
    TYPE_LEGACY_USER_LIST = 3,
    TYPE_LEGACY_EVENT = 4,
    TYPE_SESSION = 5
  }

  export interface EventDetails {
    interpretation: SearchExport.EventDetails.Interpretation;
  }

  export namespace EventDetails {
    export enum Interpretation {
      INTERPRETATION_INVALID = 0,
      INTERPRETATION_MATCHING = 1,
      INTERPRETATION_FOR_MATCHING_INDIVIDUALS = 2,
      INTERPRETATION_FOR_MATCHING_SESSIONS = 3,
      INTERPRETATION_FOR_MATCHING_PAGES = 4
    }
  }

  export enum Format {
    FORMAT_INVALID = 0,
    FORMAT_NDJSON = 1,
    FORMAT_CSV = 2,
    FORMAT_JSON = 3
  }
}
